import React, { FC } from 'react'
import NachaContainer from 'containers/Nacha'

const NachaPage: FC = () => <NachaContainer />

export default NachaPage
